import useSWR from 'swr'
import { OrganizationController } from '@/controllers'
import { config } from '@/config'
import { SeasonProgress } from '@/interfaces/seasonOrganization'
import { result } from '@/interfaces/task'

export const useSeasonProgress = (
  hasParticipants: boolean,
): {
  seasonProgress: SeasonProgress | null
  error: string | null
  isLoading: boolean
  revalidate: () => Promise<result<SeasonProgress | null>>
} => {
  const {
    data: organizationData,
    error: uncaughtError,
    isLoading,
    mutate,
  } = useSWR(
    hasParticipants ? config.api.endpoints.organization.for_participants : null,
    OrganizationController.forParticipants,
  )
  const error = organizationData?.result?.[0] || uncaughtError
  const seasonProgress = organizationData?.result?.[1] || null

  const revalidate = async () => {
    const response = await mutate()

    if (!response) {
      throw new Error('Failed to revalidate seasonProgress')
    }

    return response.result
  }

  return {
    seasonProgress,
    error,
    isLoading,
    revalidate,
  }
}
